import { StatusBtn } from "../../../../components/StatusBtn"
import { IHeat } from "../../../../models/Heat"
import { IEvent } from "../../../../models/Event"

const raceIcons: { [eventType: string]: string } = {
    run: 'directions_run',
    swim: 'pool',
    bike: 'directions_bike',
    tri: 'directions_run',
}

export const HeatBox: React.FC<{ heat: IHeat, event: IEvent }> = ({ heat, event }) => {
    const raceIcon = raceIcons[event.eventType]

    function goToRegistrationWithRolls() {
        window.location.href = `${event.registrationUrl}&skipRolls=1&skipWithRolls=${heat.Rolls}`
    }

    return (
        <article className="heat-card">
            {raceIcon && <span className="material-icons heat-card__icon" aria-hidden="true">{raceIcon}</span>}
            <h3 className="heat-card__title">{heat.description}</h3>
            <div className="heat-card__tags">
                <span className="tag">{heat.amami ? 'עממי' : 'תחרותי'}</span>
                {heat.startHeat && <span className="tag tag--muted">זינוק {heat.startHeat}</span>}
            </div>
            <StatusBtn event={event} goToRegistration={goToRegistrationWithRolls} />
        </article>
    )
}
